// extracted by mini-css-extract-plugin
module.exports = {"container":"intro-module--container--2N-U9","copy":"intro-module--copy--2sVJf","heading":"intro-module--heading--1U0Xq","bodyCopy":"intro-module--bodyCopy--2Ufhf"};